const _timers: Map<string, Timer> = new Map();
export const getTimer = (groupName?: string) => {
  if (!groupName) groupName = 'Global';
  if (_timers.has(groupName)) return _timers.get(groupName)!;
  else {
    const timer = new Timer();
    timer.groupName = groupName;
    _timers.set(groupName, timer);
    return timer;
  }
};

export const getAllTimerHistory = () => {
  return Array.from(_timers.values()).flatMap((t) => t.history);
};

type TimerExp = 'Hours' | 'Minutes' | 'Seconds';
export class Timer {
  groupName?: string;
  startTime: number;
  history: string[] = [];
  constructor() {
    this.startTime = new Date().getTime();
  }

  private lastPrintTime: number | undefined;
  get elipsedTime() {
    return new Date().getTime() - this.startTime;
  }

  reset() {
    this.startTime = new Date().getTime();
    this.lastPrintTime = undefined;
  }

  toString(exp?: TimerExp) {
    return this.parseString(this.elipsedTime, exp);
  }

  parseString(elipsedTime: number, exp?: TimerExp) {
    const hours = Math.floor(elipsedTime / 3600000);
    const minutes = Math.floor((elipsedTime - hours * 3600000) / 60000);
    const seconds = Math.floor((elipsedTime - hours * 3600000 - minutes * 60000) / 1000);
    const ms = elipsedTime % 1000;

    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');
    const paddedSeconds = String(seconds).padStart(2, '0');
    const paddedMilliseconds = String(ms).padStart(3, '0');

    switch (exp) {
      case 'Hours':
        return `${paddedHours}:${paddedMinutes}:${paddedSeconds}.${paddedMilliseconds}`;
      case 'Minutes':
        return `${paddedMinutes}:${paddedSeconds}.${paddedMilliseconds}`;
      default:
      case 'Seconds':
        return `${paddedSeconds}.${paddedMilliseconds}`;
    }
  }

  print(str?: string, exp?: TimerExp) {
    const gap = this.elipsedTime - (this.lastPrintTime ?? 0);
    this.lastPrintTime = this.elipsedTime;

    const text = `${this.groupName ? `[${this.groupName}] ` : ''}${
      str ? `${str} ` : ''
    }working time: ${this.parseString(gap, exp)} / ${this.parseString(this.elipsedTime, exp)}\n`;
    this.history.push(text);
    console.log(text);
  }
}
